import React, { useEffect, useState } from 'react';

import { Button, Container, Grid, LinearProgress, makeStyles, Typography } from '@material-ui/core';

import useBlocRef from '../../utils/useBlocRef.hook';

const useStyles = makeStyles(() => {
  return {
    container: {
      alignItems: 'center',
      display: 'flex',
      height: 100,
      justifyContent: 'center',
      margin: '20px 10px',
      padding: '50px 40px',
      width: 500,
    },
    item: {
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'center',
    },
    text: {
      textAlign: 'center',
    },
  };
});

export default () => {
  const classes = useStyles();
  const [progress, setProgress] = useState(0);
  const [uploading, setUploading] = useState(false);
  const blocRef = useBlocRef('uploadProgressBloc');

  useEffect(() => {
    const progressSubscription = blocRef.current.progress$.subscribe(setProgress);
    const uploadingSubscription = blocRef.current.uploading$.subscribe(setUploading);
    return () => {
      progressSubscription.unsubscribe();
      uploadingSubscription.unsubscribe();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleClick = () => {
    blocRef.current.close();
  };

  let text1 = `Uploading ${progress}%, please wait...`;
  let text2 = '(Auto logout will be disabled while upload is in progress)';
  if (!uploading) {
    if (progress === 100) {
      text1 = '100%';
    } else {
      text1 = 'Upload failed';
    }
    text2 = '';
  }

  return (
    <Container maxWidth="xs" disableGutters className={classes.container}>
      <Grid container justify="center" direction="column">
        <Grid item xs>
          <LinearProgress value={progress} style={{ height: 5, width: '100%' }} variant="determinate" />
          <Typography variant="subtitle1" className={classes.text}>
            {text1}
          </Typography>
          <Typography variant="subtitle1" className={classes.text}>
            {text2}
          </Typography>
        </Grid>
        {!uploading && (
          <Grid item xs className={classes.item}>
            <Button variant="contained" color="primary" onClick={handleClick}>
              Close
            </Button>
          </Grid>
        )}
      </Grid>
    </Container>
  );
};
